module.exports = __webpack_public_path__ + "img/novo-nordisk-innovationHub.0aa18dce.png";